import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import { APP_PATH_ACCOUNT } from '../../../../../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = (props) => {
  const { className, user } = props;

  const classes = useStyles();

  return (
    user && (
      <div className={clsx(classes.root, className)}>
        <Avatar
          alt="Person"
          className={classes.avatar}
          component={RouterLink}
          src={user.picture}
          to={APP_PATH_ACCOUNT}
        />
        <Typography className={classes.name} variant="h4">
          {user.name}
        </Typography>
        <Typography variant="body2">{user.plan}</Typography>
      </div>
    )
  );
};

Profile.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object
};

export default Profile;
